import { useState, useEffect } from 'react';
import AppLayout from '@/components/feature/AppLayout';
import { useAuth } from '@/context/AuthContext';


export default function SWAlertsPage() {
  const [alerts, setAlerts] = useState<any[]>([]);
  const { user } = useAuth();
  

  useEffect(() => {
    fetch(`https://guardiancloudcare.com/backend/api/get_alerts.php?uid=${user?.uid}`)
      .then(res => res.json())
      .then(data => setAlerts(data))
      .catch(err => console.error(err));
  }, []);

  const markAsRead = async (id: number) => {
    await fetch("https://guardiancloudcare.com/backend/api/mark_alert_read.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ id })
    });

    // refresh alerts
    fetch(`https://guardiancloudcare.com/backend/api/get_alerts.php?uid=${user?.uid}`)
      .then(res => res.json())
      .then(data => setAlerts(data));
  };

  return (
    <AppLayout title="My Alerts" breadcrumb={['Social Worker', 'My Alerts']}>
      <div className="flex justify-end mb-5">
        <button onClick={() => setAlerts((prev) => prev.map((a) => ({ ...a, read: true })))} className="text-sm border border-gray-200 text-gray-600 px-4 py-2 rounded-xl hover:bg-gray-50 cursor-pointer whitespace-nowrap">Mark All Read</button>
      </div>
      <div className="space-y-3">
        {alerts.map((a) => {
          const cfg = {
            critical: { icon: 'ri-alarm-warning-line', color: 'text-red-600', bg: 'bg-red-50', border: 'border-red-200' },
            warning: { icon: 'ri-error-warning-line', color: 'text-orange-600', bg: 'bg-orange-50', border: 'border-orange-200' },
            reminder: { icon: 'ri-calendar-event-line', color: 'text-amber-600', bg: 'bg-amber-50', border: 'border-amber-200' },
            info: { icon: 'ri-information-line', color: 'text-teal-600', bg: 'bg-teal-50', border: 'border-teal-200' },
          }[a.type] || { icon: 'ri-information-line', color: 'text-gray-600', bg: 'bg-gray-50', border: 'border-gray-200' };
          return (
            <div key={a.id} className={`bg-white rounded-xl border ${!a.read ? cfg.border : 'border-gray-100'} p-5`}>
              <div className="flex items-start gap-4">
                <div className={`w-10 h-10 ${cfg.bg} rounded-xl flex items-center justify-center flex-shrink-0`}><i className={`${cfg.icon} ${cfg.color} text-lg`} /></div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <p className="text-sm font-semibold text-gray-800">{a.title}</p>
                    {!a.read && <span className="w-2 h-2 rounded-full bg-red-500 flex-shrink-0" />}
                  </div>
                  <p className="text-sm text-gray-600">{a.desc}</p>
                  <p className="text-xs font-mono text-gray-400 mt-1">{a.case}</p>
                </div>
                <div className="flex gap-2 flex-shrink-0">
                  {!a.read && (
                    <button 
                      onClick={() => markAsRead(a.id)}
                      className="text-xs text-teal-500 cursor-pointer"
                    >
                      Mark Read
                    </button>
                  )}
                  <button onClick={() => setAlerts((prev) => prev.filter((al) => al.id !== a.id))} className="text-gray-300 hover:text-red-400 cursor-pointer"><i className="ri-close-line" /></button>
                </div>
              </div>
            </div>
          );
        })}
        {alerts.length === 0 && (
          <div className="bg-white rounded-xl border border-gray-100 p-12 text-center">
            <i className="ri-notification-off-line text-4xl text-gray-200 mb-3 block" />
            <p className="text-gray-400">No alerts at this time</p>
          </div>
        )}
      </div>

    </AppLayout>
  );
}
